import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchVendorPaymentList = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)
    if(payload.store_list.length === 0) {
        return false
    } else {
        axios.post('/vendorPayment/index.php', payload, accessTokenInfo.accessTokenInfo())
        .then(res => {
            
            if(res.data.status) {
                commit('setVendorPaymentList', {response: res.data.response, total: res.data.total, page_number: res.data.page_number, page_number: res.data.page_number})         
            }
        })
        .catch(error => {
            commit('displayMessageAlert', {message: error, type: 'Error'})
        })
        .finally( () => {
            commit('toggleLoadingState', false)
        })
    }
}

export const fetchVendorPaymentData = ({commit, dispatch}, payload) => {
    commit('toggleLoadingState', true)
    axios.post('/vendorPayment/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            
            commit('setVendorPaymentData', {response: res.data.response, copy: payload.copy})   
            
            if(payload.navigate) {
                router.push(router.currentRoute.fullPath+'/form/')
            }

        } else {
            commit('resetVendorPaymentData')
        }
        dispatch('fetchTaxSetting')

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitVendorPaymentData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/vendorPayment/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            if(payload.id === 0 && !payload.popup) {
               // router.push(router.currentRoute.fullPath.replace('/form/', ''))
            }
            commit('resetVendorPaymentPartial')
            dispatch('fetchVendorMasterList')       
                 
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteVendorPaymentData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/vendorPayment/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            if(payload.navBack) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else if(payload.popup) {
            } else {
                dispatch('fetchVendorPaymentList', payload.list)
            }
            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/vendorPayment/actions.js